import { PRODUCTION_ENVIRONMENT, STAGING_ENVIRONMENT, STORAGE_AUTH_DATA, STORAGE_AUTH_SDK_TOKEN, STORAGE_CREATOR_ENVIRONMENT } from "./constants";
import { getClientIDAndSecret } from "./helpers";

const BASE_URL = {
  PRODUCTION: process.env.REACT_APP_API_ENDPOINT_PRODUCTION,
  STAGING: process.env.REACT_APP_API_ENDPOINT_STAGING,
};
const SDK_CONFIG__API = "v1/dashboard/links/{link_id}/sdk-config";
const SDK_WORKPLTFORM_API = "v1/internal/work-platforms";
const SDK_GET_ACCOUNT_API = "v1/internal/accounts";
// const SDK_GET_ACCOUNT_API = "v1/accounts";
export const getSDKConfig = async (invite_code, env) => {
  try {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      environment: env,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const response = await fetch(`${BASE_URL[env]}/${SDK_CONFIG__API.replace("{link_id}", invite_code)}`, requestOptions);
    const data = await response.json();
    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getAccountInfo = async (accountId) => {
  try {
    const auth = JSON.parse(sessionStorage.getItem(STORAGE_AUTH_DATA));
    const sdkToken = auth[STORAGE_AUTH_SDK_TOKEN];
    const environment = sessionStorage.getItem(STORAGE_CREATOR_ENVIRONMENT).toLowerCase();
    var myHeaders = new Headers();
    let workplatformURL;
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${sdkToken}`);
    if (environment === STAGING_ENVIRONMENT) {
      workplatformURL = `${process.env.REACT_APP_PHYLLO_API_ENDPOINT_STAGING}/${SDK_GET_ACCOUNT_API}/${accountId}`;
    } else if (environment === PRODUCTION_ENVIRONMENT) {
      workplatformURL = `${process.env.REACT_APP_PHYLLO_API_ENDPOINT_PRODUCTION}/${SDK_GET_ACCOUNT_API}/${accountId}`;
    }
    const response = await fetch(workplatformURL, {
      headers: myHeaders,
    });
    const data = await response.json();
    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
